import { Link } from "react-router-dom";
import React from "react";

export function Logo() {
  return (
    <Link
      to="/"
      className="font-normal flex space-x-2 items-center text-sm mr-4 text-foreground px-2 py-1 relative z-20"
    >
      <img 
        src="/logo.webp"
        alt="Logo" 
        className="h-8 w-auto"
      />
    </Link>
  );
}
